export default __webpack_public_path__ + "static/media/Cart1.099ab6e7.svg";